function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last && 
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    
        

    
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const closestDrawerMenu = detailsElement.closest('.menu-drawer__menu');

  
    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }

/* Close sibling menu items */
    if (!isOpen) {  
      if (closestDrawerMenu) {
      closestDrawerMenu.querySelectorAll('details').forEach(details => details.removeAttribute('open'));
      }
    }
    
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    setTimeout(function() {
      document.body.classList.add('overflow-hidden-tablet-active');  
    }, 50);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
  //    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
  //      details.removeAttribute('open');
 //       details.classList.remove('menu-opening');
 //     });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      setTimeout(function() {
        document.body.classList.remove('overflow-hidden-tablet-active');  
      }, 50);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
//      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    setTimeout(function() {
  document.body.classList.add('overflow-hidden-tablet-active');  
}, 50);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.querySelector('.product-media-modal__content').addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {        
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
      
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
 //     this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    
    /* Low stock notice */
 /*   var stockLevel = this.currentVariant.inventory_quantity;
    var stockNotice = document.querySelector('.stock-notice');
    if(stockLevel < 10 && stockLevel > 0) {
      stockNotice.classList.remove('hidden');
    } else {
      stockNotice.classList.add('hidden');
    }

    var giftCardLink = document.querySelector('.gift-card-link');
    if (this.currentVariant.available) {
      giftCardLink.classList.add('hidden');   
    } else {
      giftCardLink.classList.remove('hidden');
    }*/
    
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
//    if (inventory) inventory.classList.add('visibility-hidden');
//    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');        
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

/* Rotating promo bar */
$(document).ready(function() {
  var $els = $('.promo-bar .promo-message'),
      i = 0,
      len = $els.length,
      speed = $('.promo-bar').data('rotation-time');
  if(len > 1) {
    $els.slice(1).hide();
    setInterval(function () {
      $els.eq(i).fadeOut(300, function () {
        i = (i + 1) % len
        $els.eq(i).fadeIn(300);
      })
    }, speed)
  }
})

// Product tabs
var $tabs = $('.description__tabs');
var $tab = $tabs.find('.tab');
var $tabTitle = $tabs.find('.tab__title');

$tabTitle.on('click keydown', function(evt) {
  var $this = this;
  var trigger = false;
  if (evt.type === 'click') {
    trigger = true;
  }
  if (evt.type === 'keydown' && evt.key == 'Enter') {
    trigger = true;
  }

  if (trigger) {
    var $tab = $(this).closest('.tab');
    var $activeTab = $tabs.find('.tab--active');

    // Close it if open
    // Otherwise close active and open new
    if ($tab.hasClass('tab--active')) {
      $tab.find('.tab__content').slideUp(400);
      $tab.removeClass('tab--active');
    } else {
      if (!$tab.parents('.description__tabs').hasClass("sizechart__tabs")) {
        $activeTab.removeClass('tab--active');
        $activeTab.find('.tab__content').slideUp(400);
      }
      $tab.find('.tab__content').slideDown(400);
      $tab.addClass('tab--active');
    }
  }
});

/* Product images zoom modal */
$('.product-media-modal__thumbs img').on('click', function(e){
  //e.preventDefault();
  var image = $(this).data('media-id');
  $('.product-media-modal__thumbs img').removeClass('active');
  $(this).addClass('active');
  document.querySelector('.product-media-modal__content img[data-media-id="' + image + '"]').scrollIntoView();
});

/*var mobileMenu = document.querySelector('#Details-menu-drawer-container');
document.addEventListener('click', function(event) {
  var isClickInside = mobileMenu.contains(event.target);
  if (!isClickInside) {
    if ($('#Details-menu-drawer-container .header__icon--menu[aria-expanded="true"]').length > 0) {
    document.querySelector('#Details-menu-drawer-container .header__icon--menu[aria-expanded="true"]').click();
    }
  }
});*/

$(document).on('click', '.collection-quick-add', function() {
  $('.collection-atc').removeClass('active')
  $(this).parents('.collection-atc').addClass('active');
});

$(document).click(function(event) { 
  var $target = $(event.target);
  if(!$target.closest('.collection-atc').length && 
     $('.collection-atc').is(":visible")) {
    $('.collection-atc').removeClass('active');
  }        
});

$(document).on('click', '.collection-variant.available', function(e){
  e.preventDefault();
  var variantID = $(this).data("variant"); 
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: variantID
    },
    dataType: 'json', 
    success: function (data) { 
      if (window.location.href.indexOf("/cart") > -1) {
        location.reload();
      }
    } 
  });
}) 

  function collectionMediaSlider() {
    $('.media--slider').slick({
      arrows: true,
      infinite: true,
      dots: true,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="true" style=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" aria-disabled="true" style=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>'
    });
    if (window.innerWidth >= 750) {
      $('.media--slider').slick('slickRemove', 1);
    }
  }
  $(document).ready(function(){
    collectionMediaSlider()
  });

 function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.currency-selector__dropdown').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });


/* Yotpo scroll to reviews section */
function scrollToElement(element) {
  window.scroll({
    behavior: 'smooth',
    left: 0,
    top: element.offsetTop
  });
}
 document.querySelectorAll('.yotpo-stars-custom').forEach(function(element) {
   element.addEventListener('click', () => {
    scrollToElement(document.getElementById("yotpo-reviews-main-widget"));
   });
 });

/* Rebuy toggle */


$('.active .featured-collection-carousel').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="true" style=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
  nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" aria-disabled="true" style=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 719,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
});

$(document).on('click', '.rebuy-toggle-switcher > div', function() {
  var parent = $(this).parents('.rebuy-toggle');
  parent.find($('.rebuy-toggle-switcher > div')).removeClass('active');
  $(this).addClass('active');
  parent.find($('.rebuy-toggle-widgets > div')).removeClass('active');
  parent.find($('.rebuy-toggle-widgets > div[data-id="' + $(this).data('id') + '"]')).addClass('active');
  setTimeout(function() {
  $('.active .featured-collection-carousel:not(.slick-initialized)').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
  prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="true" style=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
  nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" aria-disabled="true" style=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 719,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
  }, 200);
});

/* Timer function */
function Timer(fn, t) {
    var timerObj = setInterval(fn, t);
    this.stop = function() {
        if (timerObj) {
            clearInterval(timerObj);
            timerObj = null;
        }
        return this;
    }
    // start timer using current settings (if it's not already running)
    this.start = function() {
        if (!timerObj) {
            this.stop();
            timerObj = setInterval(fn, t);
        }
        return this;
    }
    // start with new or original interval, stop current interval
    this.reset = function(newT = t) {
        t = newT;
        return this.stop().start();
    }
}

/* Image with text gallery */
var imageTextSlider = $('.image-with-text-slider');
$(imageTextSlider).each(function() {
  var $this = $(this);
  var imageTextSliderCounter = 0;
  var imageTextSliderThumb = $this.find('.navigation-thumbnail');
  var imageTextSliderInterval = $this.data('speed');
  var totalSeconds = 0;
  var arrowPrev = $this.find('.image-with-text-slider-nav-arrow-prev');
  var arrowNext = $this.find('.image-with-text-slider-nav-arrow-next');
  var trigger = 'click'
  if($this.hasClass('autorotate-slider')) {
    trigger = 'mousedown'
  }
  imageTextSliderThumb.on(trigger, function() {
    imageTextSliderThumb.removeClass('active');
    $(this).addClass('active');
    $this.find('.image-with-text-left img').removeClass('active');
    $this.find('.image-with-text-right-content').removeClass('active');
    $this.find('.image-with-text-left img[data-block="' + $(this).data('block') + '"]').addClass('active');
    $this.find('.image-with-text-right-content[data-block="' + $(this).data('block') + '"]').addClass('active');
    imageTextSliderCounter = $(this).index() + 1;
    if($this.hasClass('autorotate-slider')) {
      timer.reset(imageTextSliderInterval);    
    }
  });

  arrowNext.on(trigger, function() {
    var index = $this.find('.navigation-thumbnail.active').index();
    if(index == imageTextSliderThumb.length - 1) {
      $this.find(`.navigation-thumbnail:first-child`).trigger('click');
    } else {
      $this.find(`.navigation-thumbnail:eq(${index + 1})`).trigger('click');
    }
  });

  arrowPrev.on(trigger, function() {
    var index = $this.find('.navigation-thumbnail.active').index();
    if(index == 0) {
      $this.find(`.navigation-thumbnail:last-child`).trigger('click');
    } else {
      $this.find(`.navigation-thumbnail:eq(${index - 1})`).trigger('click');
    }
  });
  
  if($this.hasClass('autorotate-slider')) {
    var timer = new Timer(function() {
      imageTextSliderThumb.eq(imageTextSliderCounter++ % imageTextSliderThumb.length).trigger(trigger);
    }, imageTextSliderInterval);
    timer.start();  
    
    document.addEventListener("mobile-menu-opened",(e) => {
        timer.stop();
      },
      false,
    );
    document.addEventListener("mobile-menu-closed",(e) => {
        timer.reset(imageTextSliderInterval);
      },
      false,
    );
  }
});
if ($(window).width() < 750) {
  console.log('yes');
  $('.image-with-text-slider.thumbnail-position-below_content .image-with-text-slider-nav').flickity({
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    draggable: true
  });
}

/* Mobile nav toggle */
$('.mobile-nav-toggle div').on('click', function() {
  var toggleElement = $('.mobile-nav-toggle div');
  var menuElement = $('.menu-drawer__menu');
  var activeMenu = $(this).data('menu');
  toggleElement.removeClass('mobile-nav-toggle-active');
  $(this).addClass('mobile-nav-toggle-active');
  menuElement.removeClass('mobile-menu-active');
  $('.menu-drawer__menu[data-menu="' + activeMenu + '"]').addClass('mobile-menu-active');
});

/* Enhanced collections nav */
$('.enhanced-collection-nav div').on('click', function() {
  var navItems = $(this).siblings();
  var groupItems = $(this).parents('.enhanced-collection-section').find('.col-nav-group');
  var currentGroup = $(this).data('nav-group');
  navItems.removeClass('col-nav-item-active');
  groupItems.removeClass('col-nav-group-active');
  $(this).addClass('col-nav-item-active');
  $(this).parents('.enhanced-collection-section').find('.col-nav-group[data-nav-group="' + currentGroup + '"]').addClass('col-nav-group-active');
});

$(window).on('load', function () {
  var enhancedCollectionNav = $('.enhanced-collection-nav');
  var enhancedCollectionNavHeight = enhancedCollectionNav.siblings('.enhanced-collections-content').find('img').height();
  enhancedCollectionNav.height(enhancedCollectionNavHeight);
});

$('.collection__layout-button').on('click', function() {

  $('.media--slider').slick('unslick');
var newLayoutMode = $(this).attr('data-layout-mode'); // We save the new attribute so that we can select the appropriate mode without causing reflow
        fetch("/cart/update.js", {
          body: JSON.stringify({
            attributes: {
              'collection_layout': newLayoutMode
            }
          }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }); // Finally, we change everything!
        $('#product-grid').attr('data-grid-layout', newLayoutMode);
        $('.collection__layout-button').removeClass('is-selected');

  console.log('test');
  setTimeout(function(){
  $('.media--slider').slick('refresh');
  }, 300);

});

window.addEventListener("resize", function() {
  $('.media--slider').slick('refresh');
}, false);


$('.toggle').click(function(e) {
  	e.preventDefault();
  
    var $this = $(this);
  
    if ($this.prev().hasClass('show')) {
        $this.prev().removeClass('show');
        $this.prev().slideUp(350);
    } else {
        $this.parent().parent().find('li .inner').removeClass('show');
        $this.parent().parent().find('li .inner').slideUp(350);
        $this.prev().toggleClass('show');
        $this.prev().slideToggle(350);
    }
});
$('.submenu-toggle').on('click', function() {
  $(this).parent().find('.toggle').trigger('click');
});

$(document).on('click', '.product-grid-quick-shop-trigger', function() {
  var element = $(this);
  $('.product-grid-quick-shop-mobile').removeClass('active');
  element.next('.product-grid-quick-shop-mobile').addClass('opening');
  $('body').addClass('overflow-hidden-tablet');  
  setTimeout(function() {
  element.next('.product-grid-quick-shop-mobile').addClass('active');
  $('body').addClass('overflow-hidden-tablet-active');  
  }, 50);
});
$(document).on('click', '.product-grid-quick-shop-close', function() {
  var element = $(this);
  element.parents('.product-grid-quick-shop-mobile').removeClass('active');
  $('body').removeClass('overflow-hidden-tablet-active');
  setTimeout(function() {
  element.parents('.product-grid-quick-shop-mobile').removeClass('opening');  
  $('body').removeClass('overflow-hidden-tablet');
  }, 300);  
});

$(document).on('change', '.product-grid-option select', function(){ 
  var form = $(this).parents('.product-grid-form'); 
  var mainSelector = form.find('.product-grid-main-selector');
  var atc = form.find('button');
  var currentValue = '';
  var optionSelector = form.find('.product-grid-option select');
  var optionSelectorLength = optionSelector.length;
  $(optionSelector).each(function(index) {
    currentValue += $(this).val();
    if (index !== (optionSelectorLength - 1)) {
  	  currentValue += ' / ';
    };
  });
  var selectedValue = mainSelector.find('option[data-title="' + currentValue + '"]');
  if (selectedValue.length) {
    selectedValue.prop('selected', true);
    if(selectedValue.data('availability')) {
      atc.html('Add to cart');
      atc.prop('disabled', false);
    } else {
      atc.html('Sold out');
      atc.prop('disabled', true);
    }
  } else {
    atc.prop('disabled', true);
    atc.html('Unavailable');
  }
});

$(document).on('click', '.product-grid-option-values input', function(){
  var form = $(this).parents('.product-grid-form');
  var mainSelector = form.find('.product-grid-main-selector');
  var atc = form.find('button');
  var currentValue = '';
  var radioSelector = form.find('.product-grid-option-values');
  var radioSelectorLength = radioSelector.length;
  $(radioSelector).each(function(index) {
    if ($(this).data('option-name') == 'color') {
      $(this).find('input:first-child').prop('checked', true);
    }
    currentValue += $(this).find('input:checked').val();
    if (index !== (radioSelectorLength - 1)) {
  	  currentValue += ' / ';
    };
  });
  // updating the main selector/atc button
  var selectedValue = mainSelector.find('option[data-title="' + currentValue + '"]');
  if (selectedValue.length) {
    selectedValue.prop('selected', true);
    if(selectedValue.data('availability')) {
      atc.html('Add to cart');
      atc.prop('disabled', false);
    } else {
      atc.html('Sold out');
      atc.prop('disabled', true);
    }
  } else {
    atc.prop('disabled', true);
    atc.html('Unavailable');
  }
});

// Product page - variant selection (graying out sold-put variants, faux atc button)

function checkOptionsSelected(e){
  var unselectedOptions = 0;
  var atcContainer = e.parents('.product__info-wrapper').find('.product-atc-container');
  e.parents('.product__info-wrapper').find('.product-form__input').each(function() {
    var checkedOption = $(this).find('input:checked').val();
    var errorMessage = $(this).find('.product-form-input-error');
    if(typeof checkedOption == 'undefined') {
      unselectedOptions++;
      if (e.hasClass('faux-atc')) {
        errorMessage.addClass('show');
      }
    } else {
      errorMessage.removeClass('show');
    }
  })
    if (unselectedOptions == 0) {
      atcContainer.removeClass('variants-not-selected');
    } else {
      atcContainer.addClass('variants-not-selected');
    }
}

$(document).on('click', '.faux-atc', function() {
  var $this = $(this);
  checkOptionsSelected($this);
});

$(document).on('click', '.product-form__input input', function() {
  var $this = $(this);
  checkOptionsSelected($this);
  var optionName = $this.attr('name').split('-')[0];
  var optionValue = $this.val();
  var availableOptions = $this.parents('.product__info-wrapper').find('.product-atc-container').data('options').split(',');
  if (optionName == 'Size') {
    $this.parents('.product__info-wrapper').find('.product-form__input input[name^="Length"]').each(function() {
      var option = optionValue + ' - ' + $(this).val();
      if (availableOptions.includes(option)) {
        $(this).removeClass('disabled');
      } else {
        $(this).addClass('disabled');
      }
    });
  } else if (optionName == 'Length') {
    $this.parents('.product__info-wrapper').find('.product-form__input input[name^="Size"]').each(function() {
      var option = $(this).val() + ' - ' + optionValue;
      if (availableOptions.includes(option)) {
        $(this).removeClass('disabled');
      } else {
        $(this).addClass('disabled');
      }
    });
  }
});

$(document).on('click', 'body.overflow-hidden-tablet-active' , function(event) {
  event.stopPropagation();
  var modal = $('.product-grid-quick-shop-mobile');
  var $target = $(event.target);
  if(!$target.closest(modal).length && 
  $(modal).is(":visible")) {
    $(modal).removeClass('active');
    $('body').removeClass('overflow-hidden-tablet-active');
    setTimeout(function() {
    $(modal).removeClass('opening');  
    $('body').removeClass('overflow-hidden-tablet');
    }, 300);  
  }        
});

$(document).on('click', '.product-grid-quick-shop-mobile .product-form__submit' , function(event) {
  event.stopPropagation();
  var modal = $('.product-grid-quick-shop-mobile');
  setTimeout(function() {
    $(modal).removeClass('active');
    $('body').removeClass('overflow-hidden-tablet-active');
    setTimeout(function() {
      $(modal).removeClass('opening');  
      $('body').removeClass('overflow-hidden-tablet');
    }, 300);    
  }, 300);         
});

$(".bottom-collection-description").on('click', function () {
   $(this).find('.bottom-collection-description-text').slideToggle(300); 
});

/* Image comparison slider */
$(document).ready(function() {	
	// If the comparison slider is present on the page lets initialise it, this is good you will include this in the main js to prevent the code from running when not needed
	if ($(".comparison-slider")[0]) {
		let compSlider = $(".comparison-slider");
	
		//let's loop through the sliders and initialise each of them
		compSlider.each(function() {
			let compSliderWidth = $(this).width() + "px";
			$(this).find(".resize img").css({ width: compSliderWidth });
			drags($(this).find(".divider"), $(this).find(".resize"), $(this));
		});

		//if the user resizes the windows lets update our variables and resize our images
		$(window).on("resize", function() {
			let compSliderWidth = compSlider.width() + "px";
			compSlider.find(".resize img").css({ width: compSliderWidth });
		});
	}
});

// This is where all the magic happens
function drags(dragElement, resizeElement, container) {
	
	// This creates a variable that detects if the user is using touch input insted of the mouse.
	let touched = false;
	window.addEventListener('touchstart', function() {
		touched = true;
	});
	window.addEventListener('touchend', function() {
		touched = false;
	});
	
	// clicp the image and move the slider on interaction with the mouse or the touch input
	dragElement.on("mousedown touchstart", function(e) {
			
			//add classes to the emelents - good for css animations if you need it to
			dragElement.addClass("draggable");
			resizeElement.addClass("resizable");
			//create vars
			let startX = e.pageX ? e.pageX : e.originalEvent.touches[0].pageX;
			let dragWidth = dragElement.outerWidth();
			let posX = dragElement.offset().left + dragWidth - startX;
			let containerOffset = container.offset().left;
			let containerWidth = container.outerWidth();
			let minLeft = containerOffset + 10;
			let maxLeft = containerOffset + containerWidth - dragWidth - 10;
			
			//add event listner on the divider emelent
			dragElement.parents().on("mousemove touchmove", function(e) {
				
				// if the user is not using touch input let do preventDefault to prevent the user from slecting the images as he moves the silder arround.
				if ( touched === false ) {
					e.preventDefault();
				}
				
				let moveX = e.pageX ? e.pageX : e.originalEvent.touches[0].pageX;
				let leftValue = moveX + posX - dragWidth;

				// stop the divider from going over the limits of the container
				if (leftValue < minLeft) {
					leftValue = minLeft;
				} else if (leftValue > maxLeft) {
					leftValue = maxLeft;
				}

				let widthValue = (leftValue + dragWidth / 2 - containerOffset) * 100 / containerWidth + "%";

				$(".draggable").css("left", widthValue).on("mouseup touchend touchcancel", function() {
					$(this).removeClass("draggable");
					resizeElement.removeClass("resizable");
				});
				
				$(".resizable").css("width", widthValue);
				
			}).on("mouseup touchend touchcancel", function() {
				dragElement.removeClass("draggable");
				resizeElement.removeClass("resizable");
				
			});
		
		}).on("mouseup touchend touchcancel", function(e) {
			// stop clicping the image and move the slider
			dragElement.removeClass("draggable");
			resizeElement.removeClass("resizable");
		
		});
}

/* Trigger our fit page based on URL parameter */
function updateHash () {
  const hash = window.location.hash;
  const url = window.location.href;
  // Add your code bellow
  if (url.includes('our-fit?gender=women')) {
    document.querySelector('#section-group-2').click();
    }
}
window.addEventListener("DOMContentLoaded", updateHash);

/* Lookbook products */
$('.product-trigger').on('click', function() {
  $(this).parents('.product-drawer-container').addClass('active');
});
$('.product-drawer-close').on('click', function() {
  $(this).parents('.product-drawer-container').removeClass('active');
});

/* Desktop quick atc - prevent click-through */
$(document).on('click', '.collection-split-variants .collection-atc-inner', function (evt) {
  if(evt.target.tagName !== 'INPUT' && evt.target.tagName !== 'LABEL' && evt.target.classList.contains('product-form__submit') || evt.target.classList.contains('faux-atc')) {
    evt.stopPropagation();
    evt.preventDefault();
  }
});

/* Append attribute function */
$.fn.appendAttr = function(attrName, suffix) {
    this.attr(attrName, function(i, val) {
        return val + suffix;
    });
    return this;
};


/* Color swatches - update name */
$('.color-swatch').on('mouseenter', function() {
  var colorName = $(this).attr('title');
  $('.color-swatches-title span').html(colorName);
});
$('.color-swatch').on('mouseleave', function() {
  var colorName = $('.color-swatch.active-swatch').attr('title');
  $('.color-swatches-title span').html(colorName);
});

/* Color swatches - move active to the first place */
function sortCollectionSwatches() {
  document.querySelectorAll('.card-wrapper .color-swatches .color-swatch.active-swatch').forEach((swatch) => {
    swatch.parentNode.prepend(swatch);
  });
}

function collectionSwatchesSlider() {
  var collectionSwatches = $('.card-wrapper .color-swatches');
  if(window.innerWidth >= 750) {
    var elemWidth = 38;
  } else {
    var elemWidth = 32;
  }
  $(collectionSwatches).each(function( index ) {
    var containerWidth = $(this).width();
    var totalSwatches = $(this).data('size');
    if (totalSwatches * elemWidth > containerWidth) {
      $(this).flickity({
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        groupCells: true
      });
      $(this).removeClass('no-slider');
    } else {
      $(this).addClass('no-slider');
    }
  });
}

sortCollectionSwatches();
collectionSwatchesSlider();

document.addEventListener('collection:filtered', function() {
  sortCollectionSwatches();
  collectionSwatchesSlider();
  collectionMediaSlider();
});

$(document).on('click', '.card-wrapper .color-swatch', function() {
  var url = $(this).data('url') + '?view=grid-ajax';
  var product = $(this).parents('.grid__item');
  var index = product.index();
  product.find('.card-wrapper .color-swatch').removeClass('active-swatch');
  $(this).addClass('active-swatch');
  $.ajax({
     url: url,
     type:'GET',
     success: function(data){
   //    product.html($(data).find('.grid__item').html());

       product.find('.card.card--product').html($(data).find('.grid__item').find('.card.card--product').html());
       product.find('.card__inner').html($(data).find('.grid__item').find('.card__inner').html()); 
       product.find('.card-information').html($(data).find('.grid__item').find('.card-information').html());  
       
       
       product.find('.media--slider').slick({
         arrows: true,
         infinite: true,
         dots: true,
         prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="true" style=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
         nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" aria-disabled="true" style=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>'
       }); 
      if (window.innerWidth >= 750) {
        product.find('.media--slider').slick('slickRemove', 1);
      }
       product.find('.product-grid-option-values input').appendAttr('name', '-' + index);
       product.find('.product-grid-option-values input').appendAttr('id', '-' + index);
       product.find('.product-grid-option-values label').appendAttr('for', '-' + index);
       collectionSwatchesSlider();
     }
  });
});

/* Add to cart function */
  function addToCart(formOrId, qty, properties) {
  let fetched;
  if (qty && (typeof formOrId === "string")) {
    const vals = {};
    vals.id = formOrId;
    vals.quantity = qty;
    vals.properties = properties;
    fetched = fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(vals),
    })
  } else {
    const form = formOrId;
    const body = new FormData(form);

    fetched = fetch('/cart/add', {
      method: 'POST',
      body
    });
  }
  fetched
    .then(function() {
      console.log('added');
    })
  }

/* Product grid - add to cart */
$(document).on('click', '.product-grid-form .product-form__submit', function() {
  var qty = 1;
  var variantId = $(this).parents('.product-grid-form').find('.product-grid-main-selector select').val();
  addToCart(variantId, qty);
});

$(document).on('change', '.mobile-facets__checkbox', function() {
  if (!$('#Filter-Availability-mobile-1').is(':checked')) {  
    $('#Filter-Availability-mobile-1').trigger('click');
  }
});

$('#mobile-search-drawer-trigger').on('click', function() {
  $('body').addClass('search-drawer-open');
  setTimeout(function() {
  $('#Search-In-Template').focus();
  }, 500);
});
$('.mobile-search-close').on('click', function() {
  $('body').removeClass('search-drawer-open');
  $('#Search-In-Template').blur();
});

/* Mobile navigation */
function openNav() {
  document.querySelector("body").classList.add('menu-open');
  document.querySelector("body").classList.add('overflow-hidden-tablet');
  document.querySelector("body").classList.add('overflow-hidden-tablet-active');
  const event = new Event("mobile-menu-opened");
  document.dispatchEvent(event);
}

function closeNav() {
  document.querySelector("body").classList.remove('menu-open');
  document.querySelector("body").classList.remove('overflow-hidden-tablet');
  document.querySelector("body").classList.remove('overflow-hidden-tablet-active');
  const event = new Event("mobile-menu-closed");
  document.dispatchEvent(event); 
}

$('.mobile-nav-trigger').on('click', function() {
  openNav();
});
$('.mobile-nav-close').on('click', function() {
  closeNav();
});

$(document).mouseup(function(e) {
  var container = $("#menu-drawer");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    closeNav();
  }
});

/* Mobile filter */
function openFilter() {
  document.querySelector("body").classList.add('filter-open');
  document.querySelector("body").classList.add('overflow-hidden-tablet');
  document.querySelector("body").classList.add('overflow-hidden-tablet-active');
  const event = new Event("mobile-filter-opened");
  document.dispatchEvent(event);
}

function closeFilter() {
  document.querySelector("body").classList.remove('filter-open');
  document.querySelector("body").classList.remove('overflow-hidden-tablet');
  document.querySelector("body").classList.remove('overflow-hidden-tablet-active');
  const event = new Event("mobile-filter-closed");
  document.dispatchEvent(event); 
}

$('.mobile-filter-trigger').on('click', function() {
  openFilter();
});
$('.mobile-filter-close').on('click', function() {
  closeFilter();
});
$(document).mouseup(function(e) {
  var container = $(".mobile-facets__inner");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    closeFilter();
  }
});

/* Multicolumn slider */
$('.multicolumn-slider').flickity({
  cellAlign: 'left',
  contain: true,
  pageDots: false,
  draggable: true,
  groupCells: 3
});

/* Image scroller */
const imageScrollerObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {

        // read index from element’s property
        let index = entry.target.elems_index;

        if (entry.isIntersecting) {
          console.log(index, entry.target, 'is visible');
          entry.target.classList.add('show');
          document.querySelector(`.image-scroller-slide-image:nth-child(${index + 1})`).classList.add('show');
        } else {
          console.log(index, entry.target, 'is hidden');    
          entry.target.classList.remove('show');
          document.querySelector(`.image-scroller-slide-image:nth-child(${index + 1})`).classList.remove('show');
        }
    })
}, { threshold: 0.5 });
if (window.innerWidth >= 990) {
  let imageScrollerElems = document.querySelectorAll('.image-scroller-content-block');
  imageScrollerElems.forEach((elem, index) => {
    elem.elems_index = index;
    imageScrollerObserver.observe(elem);
  });
}

$('.image-scroller-nav-dot').on('click', function() {
  var index = $(this).data('index');
  $(this).siblings().removeClass('active');
  $(this).addClass('active');
  $(this).parents('.image-scroller-container').find('.image-scroller-content-block').removeClass('show');
  $(this).parents('.image-scroller-container').find(`.image-scroller-content-block[data-index=${index}]`).addClass('show');
  $(this).parents('.image-scroller-container').find('.image-scroller-slide-image').removeClass('show');
  $(this).parents('.image-scroller-container').find(`.image-scroller-slide-image[data-index=${index}]`).addClass('show');
});

/* SMOOTH SCROLL */
document
  .querySelectorAll('a[href^="#"]')
  .forEach(trigger => {
      trigger.onclick = function(e) {
          e.preventDefault();
          let hash = this.getAttribute('href');
          let target = document.querySelector(hash);
          let headerOffset = 100;
          let elementPosition = target.offsetTop;
          let offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
              top: offsetPosition,
              behavior: "smooth"
          });
      };
  });
/* END SMOOTH SCROLL*/

$('.featured-reviews-slider').slick({
  arrows: true,
  infinite: true,
  dots: false,
  prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="true" style=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
  nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" aria-disabled="true" style=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
  slidesToShow: 3,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});